(function () {
  const galleries = document.querySelectorAll('[data-maison-gallery]:not([data-maison-gallery-static])');

  galleries.forEach((gallery) => {
    const frame = gallery.querySelector('.maison-residence-gallery__frame');
    if (!frame) return;

    const slides = Array.from(frame.querySelectorAll('.maison-residence-gallery__slide'));
    const controls = frame.querySelectorAll('[data-gallery-direction]');
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let intervalId;

    if (slides.length < 2) return;

    if (activeIndex < 0) activeIndex = 0;

    const showSlide = (nextIndex) => {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides[activeIndex].classList.add('is-active');
    };

    const startRotation = () => {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => showSlide(activeIndex + 1), 5000);
    };

    controls.forEach((control) => {
      control.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const direction = control.dataset.galleryDirection === 'previous' ? -1 : 1;
        showSlide(activeIndex + direction);
        startRotation();
      });
    });

    gallery.addEventListener('mouseenter', () => window.clearInterval(intervalId));
    gallery.addEventListener('mouseleave', startRotation);

    startRotation();
  });
})();
